import person from "./person.png";
import barrier from "./barrier.png";

export { person, barrier };
